import {AbstractService} from 'services/AbstractService';
import defaultsDeep from 'lodash.defaultsdeep';

const ACCOUNTS_URL = '/api/accounts';
const USER_ACCOUNTS_LIST_URL = '/api/accounts';
const ACCOUNT_CHILD_PROJECTS_LIST_URL = '/api/projects';
const ACCOUNT_PATH_URL = '/api/accounts/path';
const ACCOUNT_DETAILS_URL = '/api/accounts/{0}';

export class AccountsService extends AbstractService {
  get (accountId, axiosParams = {}) {
    return this.client.get(ACCOUNT_DETAILS_URL.format(accountId), {}, {accountId}, axiosParams);
  }

  getChildAccounts (parentAccountId, {status = 'ACTIVE', sorting = 'name'} = {}, axiosParams = {}) {
    return this.client.get(ACCOUNTS_URL, {status, sorting}, {accountId: parentAccountId}, axiosParams);
  }

  getAccountProjects (accountId, {status = null, sorting = null} = {}, axiosParams = {}) {
    return this.client.get(
      ACCOUNT_CHILD_PROJECTS_LIST_URL,
      {status, sorting},
      {accountId},
      axiosParams
    );
  }

  list (accountId, params = {}) {
    return this.client.get(USER_ACCOUNTS_LIST_URL, params, {accountId});
  }

  update (account) {
    const url = `${ACCOUNTS_URL}/${account.id}`;
    return this.client.put(url, account);
  }

  create (account, parentAccountId = null) {
    const defaultAccount = {
      id: null,
      parent_id: null,
      currency_id: null,
      name: '',
      type: 'USUAL',
      status: 'ACTIVE',
      created_at: null,
      customer_id: null,
      manager_id: null,
      components: []
    };
    const accountWithDefaults = defaultsDeep({}, account, defaultAccount);
    return this.client.post(ACCOUNTS_URL, accountWithDefaults, {accountId: parentAccountId});
  }

  async accountPath (accountId) {
    return this.client.get(ACCOUNT_PATH_URL, {}, {accountId});
  }

  // legacy method
  async getAccountChildProjects (accountId, {status = null, sorting = null} = {}) {
    return (await this.client.get(
      ACCOUNT_CHILD_PROJECTS_LIST_URL,
      {status, sorting},
      {accountId}
    )).items;
  }

  moveAccounts (account_id, moving_ids) {
    return this.client.post(`${USER_ACCOUNTS_LIST_URL}/move?${moving_ids}`, {account_id});
  }
}
